import Vue from 'vue';
import bannedIpAddressesService from '@/api/banned-ip-addresses-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';

export const getDefaultIpAddressFilterParams = () => ({});

const state = {
  ipAddresses: {},
  ipAddressFilterParams: getDefaultIpAddressFilterParams(),
  ipAddressValidationErrors: {},
};

const mutations = {
  SET_IP_ADDRESSES(state, { data }) {
    [state.ipAddresses] = data;
  },

  SET_IP_ADDRESS_FILTER_PARAMS(state, params) {
    state.ipAddressFilterParams = params;
  },

  UPDATE_IP_ADDRESSES(state, ipAddresses) {
    state.ipAddresses = ipAddresses;
  },

  SET_IP_ADDRESS_VALIDATION_ERRORS(state, validationErrors) {
    state.ipAddressValidationErrors = validationErrors;
  },

  CLEAR_IP_ADDRESS_VALIDATION_ERRORS(state, field) {
    Vue.delete(state.ipAddressValidationErrors, field);
  },
};

const actions = {
  fetchIpAddresses({ state, commit }, params) {
    commit('SET_IP_ADDRESS_FILTER_PARAMS', params);
    if (state.ipAddresses?.status) {
      // if there was data loaded already, we don't need to load it again
      return Promise.resolve(state.ipAddresses.status);
    }
    return bannedIpAddressesService.getAddresses(params).then((res) => {
      commit('SET_IP_ADDRESSES', res);
      return res;
    });
  },

  updateIpAddress({ commit }, ipAddress) {
    return bannedIpAddressesService
      .create(ipAddress)
      .then((res) => {
        commit('UPDATE_IP_ADDRESSES', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('ip_address_updated'));
        return res.data;
      })
      .catch((err) => {
        commit('SET_IP_ADDRESS_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },

  clearIpAddressValidationErrors({ commit }, field) {
    commit('CLEAR_IP_ADDRESS_VALIDATION_ERRORS', field);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
